import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Stack } from "@mui/material";
import SiteBannerLayout from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/SiteBannerLayout";
import Hero from "@/components/pages/COA/Hero";
import TrainingPartners from "@/components/pages/COA/TrainingPartners";
import HowToGetStarted from "@/components/pages/COA/HowToGetStarted";
import ExamDetails from "@/components/pages/COA/ExamDetails";
import styles from "./COA.module.scss";

const COAPageTemplate = ({ data }) => {
  const { hero, trainingPartners, howToGetStarted, examDetails } = data;

  return (
    <SiteBannerLayout>
      <Stack sx={{ width: "100%" }} className={styles.wrapper}>
        <Hero styles={styles} hero={hero} />
        <TrainingPartners styles={styles} trainingPartners={trainingPartners} />
        <HowToGetStarted styles={styles} howToGetStarted={howToGetStarted} />
        <ExamDetails styles={styles} examDetails={examDetails} />
      </Stack>
    </SiteBannerLayout>
  );
};

COAPageTemplate.propTypes = {
  data: PropTypes.shape({
    hero: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      backgroundImage: PropTypes.string,
      ctaLogo: PropTypes.string,
      ctaLogoAltText: PropTypes.string,
      ctaText: PropTypes.string,
      ctaLink: PropTypes.string
    }),
    trainingPartners: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      partners: PropTypes.arrayOf(
        PropTypes.shape({
          partner: PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            url_segment: PropTypes.string,
            logo: PropTypes.string
          })
        })
      ),
      footerText: PropTypes.string
    }),
    howToGetStarted: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      backgroundImage: PropTypes.string,
      ctaText: PropTypes.string,
      ctaLink: PropTypes.string
    }),
    examDetails: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      releaseInfo: PropTypes.shape({
        title: PropTypes.string,
        logo: PropTypes.string,
        logoAlt: PropTypes.string,
        imgLink: PropTypes.string
      }),
      details: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string
        })
      ),
      footer: PropTypes.shape({
        title: PropTypes.string,
        ctaText: PropTypes.string,
        ctaLink: PropTypes.string
      })
    })
  }).isRequired
};

export const query = graphql`
  query {
    coaJson {
      pageTitle
      hero {
        title
        description
        backgroundImage {
          publicURL
        }
        ctaLogo {
          publicURL
        }
        ctaLogoAltText
        ctaText
        ctaLink
      }
      trainingPartners {
        title
        description
        partners {
          partner {
            id
            name
            url_segment
            logo
          }
        }
        footerText
      }
      howToGetStarted {
        title
        description
        backgroundImage {
          publicURL
        }
        ctaText
        ctaLink
      }
      examDetails {
        title
        description
        releaseInfo {
          title
          logo {
            publicURL
          }
          logoAlt
          imgLink
        }
        details {
          title
          description
        }
        footer {
          title
          ctaText
          ctaLink
        }
      }
    }
  }
`;

const COAPage = ({ data }) => {
  const { coaJson } = data;

  return <COAPageTemplate data={coaJson} />;
};

export const Head = ({ data }) => <title>{data.coaJson.pageTitle}</title>;

export default COAPage;
